
export type ScenarioPriceType = "$" | "%";

export enum ModelType {
    E = "E", /* EOD */
    I = "I", /* Intra-Day */
    B = "B", /* Broker */
    X = "X", /* Experimental */
    XI = "XI" /* Experimental Intraday */
}

export interface MarketScenario {
    readonly vol: number;
    readonly price: number;
    readonly priceType: ScenarioPriceType;
}

export interface SectorScenario {
    readonly sector: string;
    readonly vol: number;
    readonly price: number;
}

export interface SecurityScenario {
    readonly security: string;
    readonly vol: number;
    readonly price: number;
    readonly priceType: ScenarioPriceType;
}

export interface ScenarioDefinitions {
    readonly asAt?: string;
    readonly modelType: ModelType;
    readonly marketScenario?: MarketScenario;
    readonly sectorScenarios?: ReadonlyArray<SectorScenario>;
    readonly securityScenarios?: ReadonlyArray<SecurityScenario>;
}

export interface TfPayoffRequest {
    readonly timeSteps?: number | null;
    readonly priceSteps?: number | null;
    readonly scenarios?: ScenarioDefinitions | null;
    readonly trades: OptionTrades;
    readonly equityTrades: EquityTrades;
    readonly priceIncrement?: number;
    readonly priceIncrementType?: PriceIncrementType;
}

export enum PriceIncrementType {
    PERCENT = "PERCENT",
    FIXED = "FIXED"
}

export function marketVolChangeOf(change: number): ScenarioDefinitions {
    const marketScenario: MarketScenario = {
        vol: change,
        price: 0,
        priceType: "%"
    };

    return {
        modelType: ModelType.B,
        marketScenario
    };
}

export function securityVolChange(security: string, change: number): ScenarioDefinitions {
    const scenario: SecurityScenario = {
        security,
        vol: change,
        price: 0,
        priceType: "%"
    };

    return {
        modelType: ModelType.B,
        securityScenarios: [scenario]
    };
}
